import styled from 'styled-components'

import { BaseCell } from '../../DataGrid.styles'

export const HeaderCellRoot = styled(BaseCell)<{
  $headerSpan: boolean
  $groupId?: number
  $isResizable?: boolean
  $topVar?: string
}>`
  background-color: ${({ theme }) => theme.header.background};
  position: sticky;
  top: ${({ $topVar }) => ($topVar ? `var(${$topVar})` : 0)};
  z-index: ${({ $isSticky }) => ($isSticky ? 3 : 2)};
  ${({ $headerSpan }) => ($headerSpan ? 'grid-row-start: 1; grid-row-end: 3' : '')};
  ${({ $isResizable }) => ($isResizable ? 'padding-right: 20px' : '')};

  color: ${({ theme }) => theme.header.color};

  ${({ theme }) =>
    theme.header.bottomBorderWidth > 0 &&
    `
      &:after {
        pointer-events: none;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        content: '';
        border-bottom: ${theme.header.bottomBorderWidth}px solid ${theme.borderColor};
      }
  `}
`

export const DragLine = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  padding-left: 16px;
  cursor: col-resize;
  opacity: 0;
  z-index: 9999;

  &::after {
    content: '';
    position: absolute;
    left: 6px;
    width: 2px;
    height: 100%;
    border-right: 1px dashed ${({ theme }) => theme.borderColorResize};
  }

  &:hover {
    opacity: 1;
  }
`
